import {
  isDevelopment,
} from '../utils/settings'

import {
  IStatus,
} from '../types/utils'

import {
  IField_Astonish_Campaign_SendMode,
  IField_Astonish_Campaign_SendMode_None,
  IField_Astonish_Campaign_SendMode_Self,
  IField_Astonish_Campaign_SendMode_Network,
  IField_Astonish_Campaign_Mode_Campaign,
  IField_Astonish_Campaign_Mode_Email,
  IField_Astonish_Campaign_Status,
  IField_Astonish_Campaign_Status_Draft,
  IField_Astonish_Campaign_Status_Scheduled,
  IField_Astonish_Campaign_Status_Sending,
  IField_Astonish_Campaign_Status_Error,
  IField_Astonish_Campaign_Status_Complete,
  IField_Astonish_Campaign_Status_Cancelled,
  IRecord_Astonish_Campaign_CRM_Query,
  IField_Astonish_Campaign_Controller_Manager,
  IField_Astonish_Campaign_Controller_Emailer,
  IRecord_Astonish_Email_Status,
  IRecord_Astonish_Email_Status_Scheduled,
  IRecord_Astonish_Email_Status_Badaddress,
  IRecord_Astonish_Email_Status_Sent,
  IRecord_Astonish_Email_Status_Lost,
  IRecord_Astonish_Email_Status_Delivered,
  IRecord_Astonish_Email_Status_Opened,
  IRecord_Astonish_Email_Status_Bounced,
  IRecord_Astonish_Email_Status_Clicked,
  IRecord_Astonish_Email_Status_Unsubscribed,
  IRecord_Astonish_Email_Status_Spamreport,
  IRecord_Astonish_Email_Status_Error,
  IField_Astonish_Webhook_Event,
  IField_Astonish_Webhook_Event_Delivered,
  IField_Astonish_Webhook_Event_Open,
  IField_Astonish_Webhook_Event_Click,
  IField_Astonish_Webhook_Event_Bounce,
  IField_Astonish_Webhook_Event_Unsubscribe,
  IQuery_Astonish_Campaign_Summary_View_Mode,
  IQuery_Astonish_Campaign_Summary_View_Mode_Collapsed,
  IQuery_Astonish_Campaign_Summary_View_Mode_Exploded,
  IField_Astonish_Campaign_Level_Parent,
  IField_Astonish_Campaign_Level_Child,
  IRecord_Astonish_Email_Grouped_Status,
  IData_Astonish_Email_Check,
} from '../types/schema/astonish'

import {
  ILayout,
} from '../types/layout'

import {
  ROLE_SCOPE_DESCENDENTS,
} from './role'

import {
  STATUS_CREATED,
  STATUS_STARTED,
  STATUS_ERROR,
  STATUS_TIMEOUT,
  STATUS_COMPLETE,
} from './system'

export const ASTONISH_WHITELIST_DOMAINS = [
  '@mailsac.com',
]

export const ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_COLLAPSED: IQuery_Astonish_Campaign_Summary_View_Mode_Collapsed = 'collapsed'
export const ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_EXPLODED: IQuery_Astonish_Campaign_Summary_View_Mode_Exploded = 'exploded'
export const ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_DEFAULT = ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_EXPLODED

export const ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODES = [
  ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_COLLAPSED,
  ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_EXPLODED,
]

export const ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_TITLES: Record<IQuery_Astonish_Campaign_Summary_View_Mode, string> = {
  [ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_COLLAPSED]: 'Collapse results',
  [ASTONISH_CAMPAIGN_SUMMARY_VIEW_MODE_EXPLODED]: 'Expand results',
}

export const ASTONISH_EMAIL_STATUS_SCHEDULED: IRecord_Astonish_Email_Status_Scheduled = 'scheduled'
export const ASTONISH_EMAIL_STATUS_BADADDRESS: IRecord_Astonish_Email_Status_Badaddress = 'badaddress'
export const ASTONISH_EMAIL_STATUS_SENT: IRecord_Astonish_Email_Status_Sent = 'sent'
export const ASTONISH_EMAIL_STATUS_LOST: IRecord_Astonish_Email_Status_Lost = 'lost'
export const ASTONISH_EMAIL_STATUS_DELIVERED: IRecord_Astonish_Email_Status_Delivered = 'delivered'
export const ASTONISH_EMAIL_STATUS_OPENED: IRecord_Astonish_Email_Status_Opened = 'opened'
export const ASTONISH_EMAIL_STATUS_BOUNCED: IRecord_Astonish_Email_Status_Bounced = 'bounced'
export const ASTONISH_EMAIL_STATUS_CLICKED: IRecord_Astonish_Email_Status_Clicked = 'clicked'
export const ASTONISH_EMAIL_STATUS_UNSUBSCRIBED: IRecord_Astonish_Email_Status_Unsubscribed = 'unsubscribed'
export const ASTONISH_EMAIL_STATUS_SPAMREPORT: IRecord_Astonish_Email_Status_Spamreport = 'spamreport'
export const ASTONISH_EMAIL_STATUS_ERROR: IRecord_Astonish_Email_Status_Error = 'error'

export const ASTONISH_EMAIL_STATUS: IRecord_Astonish_Email_Status[] = [
  ASTONISH_EMAIL_STATUS_SCHEDULED,
  ASTONISH_EMAIL_STATUS_BADADDRESS,
  ASTONISH_EMAIL_STATUS_SENT,
  ASTONISH_EMAIL_STATUS_BOUNCED,
  ASTONISH_EMAIL_STATUS_LOST,
  ASTONISH_EMAIL_STATUS_DELIVERED,
  ASTONISH_EMAIL_STATUS_OPENED,
  ASTONISH_EMAIL_STATUS_CLICKED,
  ASTONISH_EMAIL_STATUS_UNSUBSCRIBED,
  ASTONISH_EMAIL_STATUS_SPAMREPORT,
]

export const ASTONISH_EMAIL_GROUPED_STATUS: IRecord_Astonish_Email_Grouped_Status[] = [
  ASTONISH_EMAIL_STATUS_SCHEDULED,
  ASTONISH_EMAIL_STATUS_SENT,
  ASTONISH_EMAIL_STATUS_DELIVERED,
  ASTONISH_EMAIL_STATUS_OPENED,
  ASTONISH_EMAIL_STATUS_CLICKED,
  ASTONISH_EMAIL_STATUS_ERROR,
]

export const ASTONISH_EMAIL_STATUS_TITLES: Record<IRecord_Astonish_Email_Status | IRecord_Astonish_Email_Status_Error, string> = {
  [ASTONISH_EMAIL_STATUS_SCHEDULED]: 'Scheduled',
  [ASTONISH_EMAIL_STATUS_BADADDRESS]: 'Bad Address',
  [ASTONISH_EMAIL_STATUS_SENT]: 'Sent',
  [ASTONISH_EMAIL_STATUS_LOST]: 'Lost',
  [ASTONISH_EMAIL_STATUS_DELIVERED]: 'Delivered',
  [ASTONISH_EMAIL_STATUS_OPENED]: 'Opened',
  [ASTONISH_EMAIL_STATUS_BOUNCED]: 'Bounced',
  [ASTONISH_EMAIL_STATUS_CLICKED]: 'Clicked',
  [ASTONISH_EMAIL_STATUS_UNSUBSCRIBED]: 'Unsubscribed',
  [ASTONISH_EMAIL_STATUS_SPAMREPORT]: 'Spam Report',
  [ASTONISH_EMAIL_STATUS_ERROR]: 'Error',
}

// a map of status onto "progress" number
// an email can never go backwards in progress steps
// this is to prevent an "open" overiding an "unsubscribe" (for example)
export const ASTONISH_EMAIL_STATUS_LEVELS: Record<IRecord_Astonish_Email_Status, number> = {
  [ASTONISH_EMAIL_STATUS_ERROR]: 0,
  [ASTONISH_EMAIL_STATUS_SCHEDULED]: 1,
  [ASTONISH_EMAIL_STATUS_BADADDRESS]: 2,
  [ASTONISH_EMAIL_STATUS_SENT]: 3,
  [ASTONISH_EMAIL_STATUS_LOST]: 4,
  [ASTONISH_EMAIL_STATUS_DELIVERED]: 4,
  [ASTONISH_EMAIL_STATUS_OPENED]: 5,
  [ASTONISH_EMAIL_STATUS_BOUNCED]: 5,
  [ASTONISH_EMAIL_STATUS_CLICKED]: 6,
  [ASTONISH_EMAIL_STATUS_UNSUBSCRIBED]: 7,
  [ASTONISH_EMAIL_STATUS_SPAMREPORT]: 7,
}

// the map of if we find an email with a status - if it should add numbers to the other status fields
// e.g. an email is "opened" state means it has been
// * scheduled
// * sent
// * delivered
// also
export const ASTONISH_EMAIL_STATUS_INFERENCE_MAP: Record<IRecord_Astonish_Email_Status, IRecord_Astonish_Email_Status[]> = {
  [ASTONISH_EMAIL_STATUS_ERROR]: [],
  [ASTONISH_EMAIL_STATUS_SCHEDULED]: [],
  [ASTONISH_EMAIL_STATUS_BADADDRESS]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
  ],
  [ASTONISH_EMAIL_STATUS_SENT]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
  ],
  [ASTONISH_EMAIL_STATUS_BOUNCED]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
  ],
  [ASTONISH_EMAIL_STATUS_LOST]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
  ],
  [ASTONISH_EMAIL_STATUS_DELIVERED]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
  ],
  [ASTONISH_EMAIL_STATUS_OPENED]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
    ASTONISH_EMAIL_STATUS_DELIVERED,
  ],
  [ASTONISH_EMAIL_STATUS_CLICKED]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
    ASTONISH_EMAIL_STATUS_DELIVERED,
    ASTONISH_EMAIL_STATUS_OPENED,
  ],
  [ASTONISH_EMAIL_STATUS_UNSUBSCRIBED]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
    ASTONISH_EMAIL_STATUS_DELIVERED,
  ],
  [ASTONISH_EMAIL_STATUS_SPAMREPORT]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
    ASTONISH_EMAIL_STATUS_SENT,
    ASTONISH_EMAIL_STATUS_DELIVERED,
  ],
}

export const ASTONISH_EMAIL_STATUS_GROUPS: Record<IRecord_Astonish_Email_Grouped_Status, IRecord_Astonish_Email_Status[]> = {
  [ASTONISH_EMAIL_STATUS_SCHEDULED]: [
    ASTONISH_EMAIL_STATUS_SCHEDULED,
  ],
  [ASTONISH_EMAIL_STATUS_SENT]: [
    ASTONISH_EMAIL_STATUS_SENT,
  ],
  [ASTONISH_EMAIL_STATUS_DELIVERED]: [
    ASTONISH_EMAIL_STATUS_DELIVERED,
  ],
  [ASTONISH_EMAIL_STATUS_OPENED]: [
    ASTONISH_EMAIL_STATUS_OPENED,
  ],
  [ASTONISH_EMAIL_STATUS_CLICKED]: [
    ASTONISH_EMAIL_STATUS_CLICKED,
  ],
  [ASTONISH_EMAIL_STATUS_ERROR]: [
    ASTONISH_EMAIL_STATUS_BADADDRESS,
    ASTONISH_EMAIL_STATUS_BOUNCED,
    ASTONISH_EMAIL_STATUS_UNSUBSCRIBED,
    ASTONISH_EMAIL_STATUS_SPAMREPORT,
    ASTONISH_EMAIL_STATUS_ERROR,
  ],
}

export const ASTONISH_CAMPAIGN_CONTROLLER_MANAGER: IField_Astonish_Campaign_Controller_Manager = 'manager'
export const ASTONISH_CAMPAIGN_CONTROLLER_EMAILER: IField_Astonish_Campaign_Controller_Emailer = 'emailer'

export const ASTONISH_CAMPAIGN_LEVEL_PARENT: IField_Astonish_Campaign_Level_Parent = 'parent'
export const ASTONISH_CAMPAIGN_LEVEL_CHILD: IField_Astonish_Campaign_Level_Child = 'child'

export const ASTONISH_CAMPAIGN_MODE_CAMPAIGN: IField_Astonish_Campaign_Mode_Campaign = 'campaign'
export const ASTONISH_CAMPAIGN_MODE_EMAIL: IField_Astonish_Campaign_Mode_Email = 'email'

export const ASTONISH_CAMPAIGN_SENDMODE_NONE: IField_Astonish_Campaign_SendMode_None = 'none'
export const ASTONISH_CAMPAIGN_SENDMODE_SELF: IField_Astonish_Campaign_SendMode_Self = 'self'
export const ASTONISH_CAMPAIGN_SENDMODE_NETWORK: IField_Astonish_Campaign_SendMode_Network = 'network'

export const ASTONISH_CAMPAIGN_SENDMODE_TITLES: Record<IField_Astonish_Campaign_SendMode, string> = {
  [ASTONISH_CAMPAIGN_SENDMODE_NONE]: 'None',
  [ASTONISH_CAMPAIGN_SENDMODE_SELF]: 'Single Email',
  [ASTONISH_CAMPAIGN_SENDMODE_NETWORK]: 'Whole Network',
}

export const ASTONISH_CAMPAIGN_STATUS_DRAFT: IField_Astonish_Campaign_Status_Draft = 'draft'
export const ASTONISH_CAMPAIGN_STATUS_SCHEDULED: IField_Astonish_Campaign_Status_Scheduled = 'scheduled'
export const ASTONISH_CAMPAIGN_STATUS_SENDING: IField_Astonish_Campaign_Status_Sending = 'sending'
export const ASTONISH_CAMPAIGN_STATUS_ERROR: IField_Astonish_Campaign_Status_Error = 'error'
export const ASTONISH_CAMPAIGN_STATUS_COMPLETE: IField_Astonish_Campaign_Status_Complete = 'complete'
export const ASTONISH_CAMPAIGN_STATUS_CANCELLED: IField_Astonish_Campaign_Status_Cancelled = 'cancelled'

export const ASTONISH_CAMPAIGN_STATUS_DELETABLE: IField_Astonish_Campaign_Status[] = [
  ASTONISH_CAMPAIGN_STATUS_DRAFT,
]

export const ASTONISH_CAMPAIGN_STATUS_CANCELLABLE: IField_Astonish_Campaign_Status[] = [
  ASTONISH_CAMPAIGN_STATUS_SCHEDULED,
]

export const ASTONISH_CAMPAIGN_STATUS_EDITABLE: IField_Astonish_Campaign_Status[] = [
  ASTONISH_CAMPAIGN_STATUS_DRAFT,
  ASTONISH_CAMPAIGN_STATUS_SCHEDULED,
]

export const ASTONISH_CAMPAIGN_STATUS_VIEW_SUMMARY: IField_Astonish_Campaign_Status[] = [
  ASTONISH_CAMPAIGN_STATUS_SCHEDULED,
  ASTONISH_CAMPAIGN_STATUS_SENDING,
  ASTONISH_CAMPAIGN_STATUS_ERROR,
  ASTONISH_CAMPAIGN_STATUS_COMPLETE,
]

export const ASTONISH_CAMPAIGN_STATUS_TITLES: Record<IField_Astonish_Campaign_Status, string> = {
  [ASTONISH_CAMPAIGN_STATUS_DRAFT]: 'Draft',
  [ASTONISH_CAMPAIGN_STATUS_SCHEDULED]: 'Scheduled',
  [ASTONISH_CAMPAIGN_STATUS_SENDING]: 'Sending',
  [ASTONISH_CAMPAIGN_STATUS_ERROR]: 'Error',
  [ASTONISH_CAMPAIGN_STATUS_COMPLETE]: 'Complete',
  [ASTONISH_CAMPAIGN_STATUS_CANCELLED]: 'Cancelled',
}

export const ASTONISH_CAMPAIGN_STATUS_MAP: Record<IField_Astonish_Campaign_Status, IStatus> = {
  [ASTONISH_CAMPAIGN_STATUS_DRAFT]: STATUS_CREATED,
  [ASTONISH_CAMPAIGN_STATUS_SCHEDULED]: STATUS_CREATED,
  [ASTONISH_CAMPAIGN_STATUS_SENDING]: STATUS_STARTED,
  [ASTONISH_CAMPAIGN_STATUS_ERROR]: STATUS_ERROR,
  [ASTONISH_CAMPAIGN_STATUS_COMPLETE]: STATUS_COMPLETE,
  [ASTONISH_CAMPAIGN_STATUS_CANCELLED]: STATUS_TIMEOUT,
}

export const ASTONISH_FROM_ADDRESS_META_FIELD = 'astonish_from_address'
export const ASTONISH_CAMPAIGN_CONFIRM_DELAY_SECONDS = isDevelopment() ? 3 : 20
export const ASTONISH_CAMPAIGN_SENDING_UPDATE_FREQUENCY_SECONDS = isDevelopment() ? 2 : 5

export const ASTONISH_CAMPAIGN_DEFAULT_CRM_QUERY: IRecord_Astonish_Campaign_CRM_Query = {
  all: false,
  tags: [],
  scope: ROLE_SCOPE_DESCENDENTS,
}

export const ASTONISH_CAMPAIGN_DEFAULT_LAYOUT: ILayout = {
  rows: [],
}

/*

  {
  "result": {
    "email": "john.doe@gmial.com",
    "verdict": "Invalid",
    "score": 0.00089,
    "local": "john.doe",
    "host": "gmial.com",
    "suggestion": "gmail.com",
    "checks": {
      "domain": {
        "has_valid_address_syntax": true,
        "has_mx_or_a_record": true,
        "is_suspected_disposable_address": false
      },
      "local_part": {
        "is_suspected_role_address": false
      },
      "additional": {
        "has_known_bounces": false,
        "has_suspected_bounces": true
      } 
    },
    "ip_address": "123.45.67.89"
  }
}

*/

// these are the object-path fields plucked from "checks" above
export const ASTONISH_VALID_EMAIL_CHECKS: IData_Astonish_Email_Check[] = [{
  title: 'address syntax',
  field: 'domain.has_valid_address_syntax',
  expected: true,
}, {
  title: 'dns (mx or a)',
  field: 'domain.has_mx_or_a_record',
  expected: true,
}, {
  title: 'disposable address',
  field: 'domain.is_suspected_disposable_address',
  expected: false,
}, {
  title: 'previous bounces',
  field: 'additional.has_known_bounces',
  expected: false,
}]

export const ASTONISH_WEBHOOK_EVENT_DELIVERED: IField_Astonish_Webhook_Event_Delivered = 'delivered'
export const ASTONISH_WEBHOOK_EVENT_OPEN: IField_Astonish_Webhook_Event_Open = 'open'
export const ASTONISH_WEBHOOK_EVENT_CLICK: IField_Astonish_Webhook_Event_Click = 'click'
export const ASTONISH_WEBHOOK_EVENT_BOUNCE: IField_Astonish_Webhook_Event_Bounce = 'bounce'
export const ASTONISH_WEBHOOK_EVENT_UNSUBSCRIBE: IField_Astonish_Webhook_Event_Unsubscribe = 'unsubscribe'

export const ASTONISH_WEBHOOK_STATUS_NAMES: Record<IField_Astonish_Webhook_Event, IRecord_Astonish_Email_Status> = {
  [ASTONISH_WEBHOOK_EVENT_DELIVERED]: ASTONISH_EMAIL_STATUS_DELIVERED,
  [ASTONISH_WEBHOOK_EVENT_OPEN]: ASTONISH_EMAIL_STATUS_OPENED,
  [ASTONISH_WEBHOOK_EVENT_CLICK]: ASTONISH_EMAIL_STATUS_CLICKED,
  [ASTONISH_WEBHOOK_EVENT_BOUNCE]: ASTONISH_EMAIL_STATUS_BOUNCED,
  [ASTONISH_WEBHOOK_EVENT_UNSUBSCRIBE]: ASTONISH_EMAIL_STATUS_UNSUBSCRIBED,
}

export const ASTONISH_FRANCHISEE_SEND_FROM_ADDRESS_MODE = 'ASTONISH_FRANCHISEE_SEND_FROM_ADDRESS_MODE'
export const ASTONISH_FRANCHISEE_FROM_ADDRESS = 'franchisee@franchisecloud.io'